<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script setup lang="ts">
import Dialog from '@uikit/dialog/Dialog.vue'
import BuildInfo from '@/components/BuildInfo.vue'
import Logo from '@/components/Logo.vue'

import ArrowRight from '~mingcute/arrow/arrow_right_line.svg'

defineSlots<{ default(props: {}): unknown }>()
const REPOSITORY_URL = 'https://framagit.org/flopedt/flopedt'
const LICENSE_URL = 'https://framagit.org/flopedt/flopedt/-/blob/master/LICENSE'
// TODO: https://framagit.org/flopedt/FlOpEDT/-/issues/100
const CONTRIBUTION_DOCS = 'https://framagit.org/flopedt/flopedt'
const SUPPORT_URL = 'https://flopedt.org/soutenir-le-projet'
</script>

<template>
  <Dialog hide-title trigger-as-child class="about-flop" :aria-describedby="undefined">
    <template #trigger><slot /></template>
    <template #title>{{ $t('about-flop.title') }}</template>
    <template #body>
      <div class="logo">
        <Logo />
      </div>
      <div class="content">
        <div class="flop-name">flop!</div>
        <p>{{ $t('about-flop.description') }}</p>
        <p>{{ $t('about-flop.short-story') }}</p>
        <ul>
          <li>
            <ArrowRight class="list-arrow" aria-hidden="true" />
            <a :href="REPOSITORY_URL" target="_blank" rel="noreferrer">{{ $t('about-flop.source-code') }}</a>
          </li>
          <li>
            <ArrowRight class="list-arrow" aria-hidden="true" />
            <a :href="LICENSE_URL" target="_blank" rel="noreferrer">{{ $t('about-flop.license') }}</a>
            {{ /* eslint-disable-next-line @intlify/vue-i18n/no-raw-text */ '' }}
            <span class="license-spdx">(AGPL-3.0-or-later)</span>
          </li>
          <li>
            <ArrowRight class="list-arrow" aria-hidden="true" />
            <a :href="CONTRIBUTION_DOCS" target="_blank" rel="noreferrer">{{ $t('about-flop.contribute') }}</a>
          </li>
          <li>
            <ArrowRight class="list-arrow" aria-hidden="true" />
            <a :href="SUPPORT_URL" target="_blank" rel="noreferrer">{{ $t('about-flop.support') }}</a>
          </li>
        </ul>
        <BuildInfo />
      </div>
    </template>
  </Dialog>
</template>

<style scoped>
:global(.about-flop.flopui-dialog-content) {
  max-width: 620px;
}

:global(.about-flop .flopui-dialog-body) {
  padding: 1.5rem;
  display: flex;
  gap: 1.5rem;
}

.content {
  flex: 1;
}

.flop-name {
  font-family: 'FFF Tusj';
  font-size: 3rem;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: flex;
  align-items: center;
  margin-bottom: 0.25rem;
  gap: 0.5rem;
}

.list-arrow {
  width: 1.25em;
  height: 1.25em;
}

.license-spdx {
  font-size: 0.8rem;
  margin-top: 0.3em;
}
</style>
